<coin-icon-button
  type="secondary"
  icon=""
  svgIcon="ms_teams"
  [matTooltip]="
    (hasValidMailAddress ? 'employee-profile.actions.teams' : 'employee-profile.actions.unknown-email-tooltip')
      | translate
  "
  [attr.aria-label]="'employee-profile.actions.teams' | translate"
  [disabled]="!hasValidMailAddress"
  (click)="msTeamsService.openTeamsChat([employeeProfile.contactInfo.email])"></coin-icon-button>
<coin-icon-button
  type="secondary"
  icon="email"
  [matTooltip]="
    hasValidMailAddress
      ? ('employee-profile.actions.send-email-tooltip' | translate) +
        '\n' +
        ('employee-profile.actions.copy-email-tooltip' | translate)
      : ('employee-profile.actions.unknown-email-tooltip' | translate)
  "
  [attr.aria-label]="'employee-profile.actions.email' | translate"
  [disabled]="!hasValidMailAddress"
  (click)="sendMail()"
  (contextmenu)="hasValidMailAddress ? copyMail($event) : undefined"></coin-icon-button>
<coin-icon-button
  type="secondary"
  icon="event"
  [matTooltip]="
    (hasValidMailAddress ? 'employee-profile.actions.meeting' : 'employee-profile.actions.unknown-email-tooltip')
      | translate
  "
  [attr.aria-label]="'employee-profile.actions.meeting' | translate"
  [disabled]="!hasValidMailAddress"
  (click)="scheduleMeeting()"></coin-icon-button>
<coin-icon-button
  type="secondary"
  icon="save_alt"
  [matTooltip]="'employee-profile.actions.download' | translate"
  [attr.aria-label]="'employee-profile.actions.download' | translate"
  (click)="downloadVcf()"></coin-icon-button>
